import { ArrowRightIcon, PlayIcon } from "lucide-react";

import { useClientStoriesModal } from "../hooks/useClientStoriesModal";
import { clientStories } from "../data/client-stories";

export const ClientStoriesSection = () => {
  const { onOpen } = useClientStoriesModal();

  return (
    <section className="py-[72px] px-5">
      <div className="main-container-blk">
        <div className="text-center mb-[56px]">
          <h2 className="font-[MangoGrotesque-SemiBold] text-5xl font-semibold text-white mb-[22px]">
            In Their Words - Client Stories
          </h2>
          <p className="text-lg text-[#CDCFD3] max-w-[500px] mx-auto">
            Discover how clients turned real challenges into meaningful outcomes
            through innovation and collaboration.
          </p>
        </div>

        <div className="max-w-[1222px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {clientStories.map((story) => (
              <div
                key={story.title}
                onClick={() => onOpen(story.title)}
                className="p-6 bg-secondary-dark-navy-500 rounded-2xl overflow-hidden cursor-pointer border border-[#09172E] space-y-2 hover:-translate-y-1 transition-transform duration-300"
              >
                <div className="relative w-full aspect-video flex items-center justify-center rounded-lg overflow-hidden">
                  {story.thumbnail ? (
                    <img
                      src={story.thumbnail}
                      alt={story.title}
                      className="size-full object-cover"
                    />
                  ) : (
                    <div className="size-full bg-[#D7EEFF] " />
                  )}
                  <PlayIcon className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 size-[60px] text-secondary-dark-navy-500 fill-secondary-dark-navy-500 transition-transform duration-300 hover:scale-110" />
                </div>

                <div className="space-y-2">
                  <h3 className="text-xl font-semibold text-white">
                    {story.title}
                  </h3>
                  <p className="text-base text-white line-clamp-2">
                    {story.description}
                  </p>
                  <span className="text-base font-semibold text-primary-blue inline-flex items-center gap-2 transition-all duration-300 hover:gap-2.5">
                    Watch Video <ArrowRightIcon className="size-5" />
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
